import axios from "axios";

axios.defaults.baseURL = 'https://mm.multimatra.com/api/';
// axios.defaults.baseURL = "http://localhost:8000/api/";
// axios.defaults.headers.common['Authorization'] = 'Bearer'+ localStorage.getItem('access_token');
